'use strict'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Input from '../../../../components/forms/Input'
import ToastrAction from 'toastr/actions/ToastrAction'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Select from '../../../../components/forms/Select'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { hasValue } from 'utils/NumberUtil'

const NewInstallationDialog = ({
    open = false,
    closeDialog = () => { },
    title = '',
    onValidate = () => { },
}) => {
    const dispatch = useDispatch()

    const {
        installationsTypes,
    } = useSelector(store => ({
        installationsTypes: store.InstallationReducer.installationsTypes,
    }), shallowEqual)

    const [code, setCode] = useState()
    const [installationType, setInstallationType] = useState()

    const onSave = () => {
        if (code && hasValue(installationType)) {
            onValidate({ code, installationType })
        } else {
            dispatch(ToastrAction.info(i18n.pleaseCompleteAllField))
        }
    }

    return (
        <Dialog
            open={open}
            PaperProps={{
                sx: {
                    minHeight: 'auto',
                    maxHeight: 'auto',
                },
            }}
        >
            <DefaultDialogTitle title={title} onClose={closeDialog} />
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <Select
                            label={i18n.installationType}
                            value={installationType}
                            onChange={setInstallationType}
                            options={installationsTypes.filter(it => it.display)}
                            keyLabel='name'
                            keyValue='code'
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.code}
                            onChange={setCode}
                            noSpace
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    onClick={onSave}
                >
                    {i18n.save}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

NewInstallationDialog.propTypes = {
    open: PropTypes.bool,
    closeDialog: PropTypes.func,
    title: PropTypes.string,
    onValidate: PropTypes.func,
}

export default NewInstallationDialog
